export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8528.2264e8b0.jpg";